import styled from "styled-components"
import { Link } from "react-router-dom"

import SVGIcon from "components/presenters/common/SVGIcon"

export default function GroupHeader({ isChallenge, title, linkPath }) {
  return (
    <HeaderBlock>
      {isChallenge && <HeaderTop>{"환급 챌린지"}</HeaderTop>}
      <HeaderBottom to={linkPath}>
        <HeaderBottomLeft>{title}</HeaderBottomLeft>
        <HeaderBottomRight>
          <SVGIcon name={"arrow"} />
        </HeaderBottomRight>
      </HeaderBottom>
    </HeaderBlock>
  )
}

const HeaderBlock = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: calc(100vw * (10 / 375));
`

const HeaderTop = styled.div`
  font-size: calc(100vw * (12 / 375));
  font-weight: 700;
  line-height: calc(100vw * (17.38 / 375));
  color: #ff9b57;
  margin-bottom: calc(100vw * (5 / 375));
`

const HeaderBottom = styled(Link)`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const HeaderBottomLeft = styled.h3`
  font-size: calc(100vw * (16 / 375));
  font-weight: 500;
  line-height: calc(100vw * (23.17 / 375));
`

const HeaderBottomRight = styled.div`
  width: calc(100vw * (8 / 375));
  height: calc(100vw * (14 / 375));

  svg {
    color: #828282;
  }
`
